import { render } from "./Accent.vue?vue&type=template&id=5d29570e&ts=true"
import script from "./Accent.vue?vue&type=script&lang=ts"
export * from "./Accent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__